var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bound } from "@frui.ts/helpers";
import { observable, runInAction } from "mobx";
import { isResourceDictionary, } from "../contracts/localeProvider";
export default class LocalizationService {
    provider;
    currentLocale;
    resources;
    currentPluralRules;
    constructor(provider) {
        this.provider = provider;
    }
    initialize(defaultLocale) {
        return this.setLocale(defaultLocale);
    }
    getAvailableLocales() {
        return this.provider.getAvailableLocales();
    }
    async setLocale(locale) {
        const resources = await this.provider.fetchResources(locale);
        runInAction(() => {
            this.currentLocale = locale;
            this.resources = resources;
            this.currentPluralRules = new Intl.PluralRules(locale);
        });
    }
    translateGeneral(code, placeholders) {
        const translated = this.translate(this.resources.general, code);
        return placeholders ? this.processTemplate(translated, placeholders) : translated;
    }
    translateModel(name, size) {
        const pluralForm = this.getPluralForm(size);
        return this.translate(this.resources.models.models, `${name}.${pluralForm}`);
    }
    translateAttribute(model, attribute) {
        let resource = this.findResource(this.resources.models.attributes, `${model}.${attribute}`);
        if (!resource) {
            resource = this.findResource(this.resources.attributes, attribute);
        }
        if (!resource) {
            console.warn(`Could not find localized attribute name '${attribute}' for '${model}'.`);
            return attribute;
        }
        return resource;
    }
    formatDate(date, options) {
        return date ? date.toLocaleDateString(this.currentLocale, options) : "";
    }
    formatTime(time, options) {
        return time ? time.toLocaleTimeString(this.currentLocale, options) : "";
    }
    formatDateTime(date, options) {
        return date ? date.toLocaleString(this.currentLocale, options) : "";
    }
    formatNumber(number, options) {
        return number !== undefined ? number.toLocaleString(this.currentLocale, options) : "";
    }
    processTemplate(template, params) {
        return template.replace(LocalizationService.placeholderRegex, (match, key) => params[key]);
    }
    translate(root, code) {
        const resource = this.findResource(root, code);
        if (resource) {
            return resource;
        }
        else {
            console.warn(`Could not find localized resource '${code}'.`);
            return code;
        }
    }
    findResource(root, code) {
        if (!code) {
            return undefined;
        }
        let scope = root;
        const segments = code.split(".");
        for (const key of segments) {
            if (!isResourceDictionary(scope)) {
                return undefined;
            }
            scope = scope[key];
        }
        return scope;
    }
    static placeholderRegex = /%\{(\w+)\}/g;
    getPluralForm(size = 1) {
        return this.currentPluralRules.select(size);
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], LocalizationService.prototype, "currentLocale", void 0);
__decorate([
    observable.ref,
    __metadata("design:type", Object)
], LocalizationService.prototype, "resources", void 0);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], LocalizationService.prototype, "translateGeneral", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], LocalizationService.prototype, "translateModel", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", String)
], LocalizationService.prototype, "translateAttribute", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", String)
], LocalizationService.prototype, "formatDate", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", String)
], LocalizationService.prototype, "formatTime", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", String)
], LocalizationService.prototype, "formatDateTime", null);
__decorate([
    bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", String)
], LocalizationService.prototype, "formatNumber", null);
//# sourceMappingURL=localizationService.js.map